<template lang="pug">
  #Loader.loader(v-show="show")
    .container-loader
      .message(v-if="message") {{ message }}
      .spinner
</template>

<script>
export default {
  name: 'Loader',

  props: {
    message: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="stylus" scoped>
.loader
  display flex
  justify-content center
  align-items center
  text-align center
  margin 2rem

.container-loader
  display flex
  flex-direction column
  justify-content center
  align-items center
  gap 1rem

.message
  color var(--color-font-principal)
  font-size 1.2rem
  text-align center
  margin-bottom 1rem

.spinner
  width 4rem
  height 4rem
  border-radius 50%
  background radial-gradient(farthest-side,var(--color-font-principal) 94%,#0000) top/1px 1px no-repeat, conic-gradient(#0000 30%,var(--color-font-principal))
  mask radial-gradient(farthest-side,#0000 calc(100% - 1px),#000 0)
  -webkit-mask radial-gradient(farthest-side,#0000 calc(100% - 1px),#000 0)
  animation spinner-c7wet2 .5s infinite linear

@keyframes spinner-c7wet2
  100%
    transform rotate(1turn)
</style>



// WEBPACK FOOTER //
// src/components/layout/Loader.vue